import { store } from "react-easy-state";

const state = store({
  palette: [],
  selectedIndex: 0,
  brush: {
    size: 20,
    sizeControl: true,
    hardness: 100,
    flow: 100,
    flowControl: false,
    opacity: 100,
    spacing: 15,
    roundness: 100,
    angle: 0,

    enumSelection: 0,
    bool1: true,
    bool2: true,
    bool3: false
  }
});

for (let i = 0; i < 256; i++) {
  state.palette.push([i, i, i]);
}
state.palette[0] = [255, 0, 0];

export default state;
